var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'automation-sidebar-wrapper',
    _vm.isFullScreen && 'hidden'
  ]},[(_vm.editableItem)?_c('SidebarEditable',{attrs:{"item":_vm.editableItem}}):_c('SidebarElements')],1)}
var staticRenderFns = []

export { render, staticRenderFns }